<template>
  <div id="export-csv-modal">
    <v-dialog v-model="modal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">CSVファイルの送付先を入力する</span>
        </v-card-title>
        <v-card-text>
          <v-form refs="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="メールアドレス"
                  required
                  v-model="form.email"
                  :rules="validation.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" text>閉じる</v-btn>
          <v-btn @click="$emit('submit', form.email)" text :disabled="!valid"
            >送信</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ExportCsvModal",
  props: { modal: { type: Boolean, default: () => false } },
  data() {
    return {
      form: { email: "" },
      valid: false,
      validation: {
        email: [
          (v) => !!v || "入力が必要な項目です。",
          (v) =>
            /.+@.+\..+/.test(v) || "有効なメールアドレスを入力してください。",
        ],
      },
    };
  },
};
</script>

<style></style>
